"use strict";
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * eloomi-learning-persona (1.0)
 * - This service is using new eloomi project structure. You should be able to make HTTP calls from this UI.
 *
 * The version of the OpenAPI document: 1.0

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersReportingApiFactory = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * UsersReportingApi - axios parameter creator
 * @export
 */
const UsersReportingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUserCoursesReport: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('downloadUserCoursesReport', 'userId', userId);
            const localVarPath = `/learning/persona/reporting/users/{userId}/courses/download`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} userId
         * @param {string} [start]
         * @param {string} [end]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCoursesMetrics: async (userId, start, end, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserCoursesMetrics', 'userId', userId);
            const localVarPath = `/learning/persona/reporting/users/{userId}/courses/metrics`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (start !== undefined) {
                localVarQueryParameter['Start'] = (start instanceof Date) ?
                    start.toISOString() :
                    start;
            }
            if (end !== undefined) {
                localVarQueryParameter['End'] = (end instanceof Date) ?
                    end.toISOString() :
                    end;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} userId
         * @param {string} [filters]
         * @param {string} [sorts]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCoursesReport: async (userId, filters, sorts, page, pageSize, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserCoursesReport', 'userId', userId);
            const localVarPath = `/learning/persona/reporting/users/{userId}/courses`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "1.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (filters !== undefined) {
                localVarQueryParameter['Filters'] = filters;
            }
            if (sorts !== undefined) {
                localVarQueryParameter['Sorts'] = sorts;
            }
            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersReportingApi - functional programming interface
 * @export
 */
const UsersReportingApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersReportingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUserCoursesReport(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadUserCoursesReport(userId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} userId
         * @param {string} [start]
         * @param {string} [end]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCoursesMetrics(userId, start, end, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCoursesMetrics(userId, start, end, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} userId
         * @param {string} [filters]
         * @param {string} [sorts]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCoursesReport(userId, filters, sorts, page, pageSize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCoursesReport(userId, filters, sorts, page, pageSize, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * UsersReportingApi - factory interface
 * @export
 */
const UsersReportingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersReportingApiFp(configuration);
    return {
        /**
         *
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUserCoursesReport(userId, options) {
            return localVarFp.downloadUserCoursesReport(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} userId
         * @param {string} [start]
         * @param {string} [end]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCoursesMetrics(userId, start, end, options) {
            return localVarFp.getUserCoursesMetrics(userId, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} userId
         * @param {string} [filters]
         * @param {string} [sorts]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCoursesReport(userId, filters, sorts, page, pageSize, options) {
            return localVarFp.getUserCoursesReport(userId, filters, sorts, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UsersReportingApiFactory = UsersReportingApiFactory;
//# sourceMappingURL=users-reporting-api.js.map